import { makeStyles } from "@mui/styles";
const useLandingPageFooterStyles = makeStyles(() => {
  return {
    footer: {
      fontFamily: "Lato !important",
      fontSize: "18px !important",
      fontWeight: "400 !important",
      lineHeight: "30px !important",
      color: "#000000 !important",
      textAlign: "center",
      margin: "30px !important",
      "&.mobile": {
        fontSize: "15px !important",
      },
    },
  };
});

export default useLandingPageFooterStyles;
